import React from 'react';

type dataSource = {
  id?: string;
  option: 'pix' | 'novo_cartao' | 'cartao_cadastrado' | 'debito' | 'qlub';
  card: any;
  text1: string;
  text2: string;
  children?: React.ReactNode;
};

export interface Props {
  data: dataSource[];
  setOptionSelected: React.Dispatch<React.SetStateAction<string>>;
  setPagOnlineSelecionado: React.Dispatch<React.SetStateAction<{}>>;
  optionSelected?: string;
}

const CardSelectOptions: React.FC<Props> = ({ data, setOptionSelected, setPagOnlineSelecionado, optionSelected }) => {
  //const { dadosApp, user } = useContext(GlobalContext);
  const [checked, setChecked] = React.useState('');

  const getItemId = (item: dataSource, index: number) => `${index}${item.text1.trim()}`;

  React.useEffect(() => {
    const selectedIndex = data?.findIndex((item) => item.option === optionSelected);

    if (selectedIndex >= 0) {
      setChecked(getItemId(data[selectedIndex], selectedIndex));
    }
  }, [data, optionSelected]);

  const handleOnClick = (item: dataSource, id: string) => {
    setChecked(id);
    setOptionSelected(item.option);

    item.card.metodo_pagamento = item.option === 'pix' ? 11 : item.option === 'debito' ? 12 : 0;

    //if (item.option === 'cartao_cadastrado')
    setPagOnlineSelecionado(item.card);
  };
  // border: 2px solid rgb(80, 167, 115);
  // background: rgb(215, 236, 223);
  return (
    <div style={{ marginTop: data?.length > 0 ? 20 : 0 }}>
      {data?.map((item, index) => {
        const itemId = getItemId(item, index);
        return (
          <React.Fragment key={itemId}>
            <div
              className="cardShadow"
              onClick={() => {
                handleOnClick(item, itemId);
              }}
              style={{
                margin: '1px 20px',
                padding: 10,
                //border: checked === item.id ? '2px solid #ced4da' : '2px solid #f7f7f7',
                border: checked === itemId ? '2px solid rgb(80, 167, 115)' : '2px solid #f7f7f7',
                background: checked === itemId ? 'rgb(215, 236, 223)' : '#FFFFFF',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  padding: '10px',
                  //background: '#f5f6f6',
                  //borderTop: '1px solid rgb(235, 235, 235)',
                  //borderBottom: '1px solid rgb(235, 235, 235)',
                }}
              >
                <label
                  className="containerInputRadio"
                  htmlFor={itemId}
                  style={{
                    //color: checked === item.id ? '#00376b' : '#54656f', //e54750, 54656f
                    color: checked === itemId ? '#e54750' : '#00376b',
                    marginBottom: 0,
                    //fontWeight: '500',
                  }}
                >
                  {item.text1}
                  <div style={{ color: checked === itemId ? '#000000' : 'rgb(115, 115, 115)', fontSize: 14 }}>
                    {item.text2}
                  </div>
                  <input
                    id={itemId}
                    type="radio"
                    value={itemId}
                    name="opcao"
                    checked={checked === itemId}
                    onChange={() => handleOnClick(item, itemId)}
                  />
                  <span
                    className="checkmark"
                    style={{ top: item.text2 ? 12 : 2, border: checked === itemId ? '2px solid #e54750' : '' }}
                  ></span>
                </label>
                {/* {checked === item.id && item.children} */}
              </div>
            </div>
            {/* {item.children} */}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CardSelectOptions;
